import React from 'react'
import NoValue from '../NoValue'

// class Thumb extends React.Component {
//   state = {
//     loading: false,
//     thumb: undefined,
//   };

//   componentDidMount() {
//     this.loadImage(this.props);
//   }
  
//   componentWillReceiveProps(nextProps) {
//     this.loadImage(nextProps);
//   }

//   loadImage(props) {
//     if (!props.file) { return; }

//     this.setState({ loading: true }, () => {
//       let reader = new FileReader();

//       reader.onloadend = () => {
//         this.setState({ loading: false, thumb: reader.result });
//       };

//       reader.readAsDataURL(props.file);
//     });
//   }

//   render() {
//     const { file } = this.props;
//     const { loading, thumb } = this.state;

//     if (!file) { return null; }

//     if (loading) { return <p>loading...</p>; }

//     return (<img src={thumb}
//       alt={file.name}
//       className="img-thumbnail mt-2"
//       height={200}
//       width={200} />);
//   }
// }

export default
class FileUploadField extends React.Component {

  render() {
    const { form, field, isEditing } = this.props;
    
    return(
      <div className="FileUpload">

        {
          field.value && field.value.path &&
          <img src={field.value.path} alt="" />
        }
        {
          !(field.value && field.value.path) && !isEditing && 
          <NoValue />
        }
        
        {
          isEditing &&
          <input id={field.name} name={field.name} type="file" onChange={async (event) => {

            const file = event.currentTarget.files[0];

            const data = new FormData();
            data.append('file', file);

            await this.setState({
              isUploading: true,
            })

            var promise = fetch('/api/upload', {
              method: 'POST',
              body: data,
            })
            .then(res => res.json())

            var _uploads = form.values._uploads || [];
            _uploads.push(promise);
            
            form.setFieldValue('_uploads', _uploads);

            var res = await promise;

            form.setFieldValue(field.name, res);
          }} />
        }


      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/modules/form/components/input/FileUpload.jsx